const Loading = ({ showText }) => {
  const displayText = showText !== false; // Default to true

  return (
    <div className="flex flex-col items-center justify-center gap-3">
      {/* Spinner */}
      <div
        className="h-12 w-12 border-4 border-gray-200 border-t-primary-default rounded-full animate-spin"
      />

      {/* Loading text */}
      {displayText && (
        <span className="text-base font-medium text-primary-default">
          Loading...
        </span>
      )}
    </div>
  );
};

export default Loading;

